<template>
  <el-table
    :data="tableData"
    header-cell-class-name="table-header__cell"
    row-class-name="table-row"
    cell-class-name="table-row__cell"
  >
    <el-table-column
      v-for="elem in Object.keys(tableColumns)"
      :key="elem"
      :prop="elem"
      :label="tableColumns[elem].lbl.value || tableColumns[elem].lbl"
      :width="tableColumns[elem].width || ''"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
				<span
					@click="copyToClipboard(scope.row[elem.toUpperCase()])"
				>
					<Icon
						v-if="tableColumns[elem].link"
						iconName="Copy"
						iconColor="#788694"
						class="copy-icon"
					/>
				</span>
        <span>
          {{ scope.row[elem.toUpperCase()] }}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { errorMsg } from '@/utils/mixins';
import { Table } from 'element-ui';
import { TableColumn } from 'element-ui';
import Icon from '../Icon/Icon';

export default {
  mixins: [errorMsg],
  props: {
    module: {
      type: String,
      default: ''
    },
    singleSelect: Boolean,
    multipleSelect: Boolean,
    tableColumns: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      currentRow: null,
      resizeObserver: null,
      multipleSelection: []
    };
  },
  methods: {
    copyToClipboard(string) {
      navigator.clipboard.writeText(string).then(() => {
        this.showNotification({
          message: 'Ссылка скопирована в буфер обмена',
					type: 'success'
        });
      });
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    Icon
  }
};
</script>

<style lang="scss" scoped>
.el-table {
  width: 100%;
  border: 1px solid $grey8;
  border-radius: 4px;

  & ::v-deep .el-table__body-wrapper {
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  &.el-table--scrollable-x {
    border-bottom: none;
  }

  & ::v-deep .table {
    &-header {
      &__cell {
        color: $grey64;
        max-height: 57px;

        & > .cell {
          line-height: 20px;
          white-space: nowrap;
        }

        &:first-of-type {
          padding: 14px 0;

          & > .cell {
            padding: 0px 8px 0px 16px;
          }
        }

        &:not(:first-of-type) {
          & > .cell {
            padding: 0px 8px;
          }
        }
      }
    }

    &-row {
      &:hover {
        & > .table-row__cell {
          background-color: $blue8 !important;
        }
      }

      &:last-child {
        .el-table__cell {
          height: 49px;
          border-bottom: none;
        }
      }

      &__cell {
        color: $grey64;

        .cell {
          color: $grey80;
          font-size: 15px;
          line-height: 24px;

          .copy-icon {
            cursor: pointer;
          }
        }

        &--name {
          display: flex;
          gap: 8px;
          align-items: center;
          cursor: pointer;

          a {
            text-decoration: none;
          }
        }

        &--user-text {
          display: flex;
          align-items: center;

          svg {
            min-width: 16px;
            width: 16px;
            height: 16px;
          }
        }

        &:first-of-type {
          padding: 12px 0;

          & > .cell {
            padding: 0px 8px 0px 16px;
          }
        }

        &:not(:first-of-type) {
          & > .cell {
            padding-top: 0;
            padding-bottom: 0;
          }
        }
      }
    }
  }

  &::before {
    height: 0;
  }
}
</style>
